import * as React from 'react';
import { MiniUserListView } from './MiniUserListView';
import * as Services from '../../../../Services/Services';
import { IStatusMessage } from '../../../../Models/IStatusMessage';
import { IAdminApi } from '../../../../Services/API/Admin/IAdminApi';
import { useBoolean } from '@fluentui/react-hooks';
import { IUserListItem } from '../../../../Models/Admin/IUserListItem';
import { ITag, MessageBarType, Stack } from '@fluentui/react';
import { IAttendee } from '../../../../Models/Attendees/IAttendee';

interface IMiniUserListProps {
    selectionChanged: (selection: IAttendee[]) => void;
}

export interface IUserTag extends ITag {
    data: IUserListItem
}


export const MiniUserList: React.FunctionComponent<IMiniUserListProps> = (props) => {

    const [userListItem, setUserListItem] = React.useState<IUserListItem[]>([])

    const [tags, setTags] = React.useState<IUserTag[]>([])

    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()


    React.useEffect(() => {
        setTags(userListItem?userListItem.map(item => {
            return {
                key: item.id, name: (item.company ? item.company : `${item.firstName} ${item.lastName}`), data: item
            }
        }):[]);
    }, [userListItem])

    const find = async (text: string) => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const adminApi = Services.ServicesProvider.GetService<IAdminApi>(Services.AdminApi);
        const users = await adminApi.getUsers(text,"",false);

        if (users.isSuccess && users.data) {            
            setStatusMessage({ message: users.message, type: MessageBarType.success });
            setIsLoading.setFalse();
            const d = users.data ? users.data.map(item => {
                return {
                    key: item.id, name: (item.company ? item.company : `${item.firstName} ${item.lastName}`), data: item
                }
            }) : []
            return d;
        }
        else {
            setStatusMessage({ message: users.message, type: MessageBarType.error });
            setIsLoading.setFalse();
        }
        return [];
    }

    return (<Stack>
             <MiniUserListView isLoading={isLoading} find={find} selectionChanged={props.selectionChanged} />
        </Stack>)
}
